<template>
    <b-modal ref="mdlAccettazioneNRE" id="mdlAccettazioneNRE" size="xl" @shown="onShownModal"
        style="height: 100%; width: 100%" no-close-on-backdrop no-close-on-esc hide-header-close
        title="Accettazione Tramite Numero Ricetta Elettronica">
        <div class="sa-ft-grid">
            <div class="sa-ft-field flex-main">
                <div class="sa-ft-icon-box">𝄃𝄃𝄂𝄀𝄁𝄃𝄂𝄂𝄃</div>
                <div class="sa-ft-inner-row">
                    <div class="sa-ft-inner-column flex-main">
                        <label class="sa-ft-form-label">Numero di Ricetta Elettronica</label>
                        <input class="sa-ft-form-input" v-model="nre" type="text">
                    </div>
                    <button type="button" @click="onRicercaAssistito" class="sa-ft-action-btn primary">
                        <span>Ricerca</span>
                        <small>🔍</small>
                    </button>
                </div>
            </div>
        </div>
        <section class="sa-ft-section-container" v-if="jsonData != null && isCallComplete">
            <div class="sa-ft-form-card">
                <div class="sa-ft-card-header">
                    <div class="sa-ft-section-icon">📝</div>
                    <h3>Informazioni Anagrafiche </h3>
                </div>
                <div class="sa-ft-grid" style="gap: 15px;">
                    <div class="sa-ft-field flex-3">
                        <div class="sa-ft-icon-box">🆔</div>
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Codice Fiscale</label>
                            <span class="sa-ft-value">{{ jsonData.patient.code }}</span>
                        </div>
                    </div>
                    <div class="sa-ft-field flex-3">
                        <div class="sa-ft-icon-box">👤</div>
                        <div class="sa-ft-data">
                            <label class="sa-ft-label">Nominativo</label>
                            <span class="sa-ft-value">{{ jsonData.patient.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="sa-ft-card-header">
                    <div class="sa-ft-section-icon">🚀</div>
                    <h3>Prestazioni </h3>
                </div>
                <div class="sa-flexbox-body" style="height: 200px !important;">
                    <div class="b-table-sticky-header">
                        <div class="sa-ft-modern-cards-wrapper">
                            <div class="sa-ft-modern-card sa-ft-modern-card-default" v-for="item, i in jsonData.details"
                                :key="i">
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field-normal flex-auto">
                                        <div class="sa-ft-data">
                                            <span class="sa-ft-data-value"
                                                style="font-size: 2.0rem; line-height: 1;">⚡</span>
                                            <span class="text-center bold"> {{ i + 1 }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field-normal flex-auto">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-data-label">Prestazione</label>
                                            <span class="sa-ft-data-value">{{ item.service.name }}</span>
                                            <span class="sa-ft-data-value-sub cursive">{{ item.service.code }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field-normal flex-2 text-center">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-data-label">Branca</label>
                                            <span class="sa-ft-data-value">
                                                <span class="sa-ft-badge primary">
                                                    <span class="sa-ft-data-value">{{ item.specialization.name }}</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field-normal flex-1 text-center">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-data-label">Stato</label>
                                            <span class="sa-ft-data-value">
                                                <span class="sa-ft-badge primary">
                                                    {{ item.status.name.toUpperCase() }}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field-normal flex-auto text-center">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-data-label">Quantita</label>
                                            <span class="sa-ft-data-value">
                                                <span class="sa-ft-badge primary">
                                                    {{ item.quantity }}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field-normal flex-auto text-center">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-data-label">Tariffa</label>
                                            <span class="sa-ft-data-value">
                                                <span class="sa-ft-badge primary">
                                                    {{ item.price }}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field-normal flex-1 text-center">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-data-label">Appuntamento</label>
                                            <span class="sa-ft-data-value" v-if="item.booking">
                                                <div class="sa-ft-valore-pai small">
                                                    <div>Inizio: {{ formatDate(item.service.startDate) }} {{
                                                        formatTime(item.booking.startTime) }}</div>
                                                    <div v-if="item.booking">Fine: {{ formatDate(item.service.endDate)
                                                    }} {{
                                                            formatTime(item.booking.endTime) }}
                                                    </div>
                                                    <div v-else class="text-muted">Fine: --</div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                    <!--  <div class="sa-ft-field-normal flex-1 text-end">
                                        <div class="sa-ft-data">
                                            <div style="gap: 8px;"
                                                class="d-flex justify-content-md-end justify-content-between">
                                               <b-button v-b-tooltip.hover size="sm" variant="outline-primary"
                                                    title="Gestisci Ricetta"
                                                    class="rounded-circle sa-ft-floating-btn secondary">
                                                    <b-icon icon="clipboard"></b-icon>
                                                </b-button> 

                                            </div>
                                        </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <template #modal-footer>
            <b-button variant="secondary" @click="closeModalAccettazioneNre()">Chiudi</b-button>
        </template>
    </b-modal>
</template>

<script>
import toast from "../../../../template/layout/utility/sa-toast";
import SaccSarrMixin from "../mixins/SaccSarrMixin"

export default {
    mixins: [SaccSarrMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            nre: null,
            jsonData: {
                patient: {
                    code: null,
                    name: null,
                },
                details: []
                //details: [{ "id": 77579178, "service": { "id": "89.7A.3_0_N24", "code": "89.7A.3_0", "name": "PRIMA VISITA CARDIOLOGICA. INCLUSO: ECG (89.52)", "startDate": "2024-12-30T00:00:00.000+00:00", "endDate": "2999-12-31T00:00:00.000+00:00", "weight": 1, "groupId": "PA" }, "specialization": { "id": "24-08", "name": "CARDIOLOGIA - 24" }, "requiresSpecificConsent": false, "price": 33.6, "variablePrice": "N", "quantity": 1, "booking": { "id": "26075826", "code": "11711200000126", "startTime": "1900-01-01T11:40:00Z", "endTime": "1900-01-01T12:00:00Z", "diary": { "id": "16929821" }, "registrationUser": { "id": "1002323", "name": "BRNFPP97B07H501V" } }, "executionUnit": { "id": "UE-FRO-00016668", "name": "[CASRAFCARDGAMB] - CARDIOLOGIA DOTT. GAMBARDELLA" }, "scheduledDatetime": "2026-04-28T10:40:00Z", "executionDatetime": "2026-04-28T10:40:00Z", "status": { "id": "ACT", "name": "Accettata" }, "enable": "Y", "statusReason": { "id": "3", "name": "Indicazione del medico erogatore" }, "phoneNumber": "3123123123", "site": { "id": "SIT-FRO-00000951", "name": "SAN RAFFAELE CASSINO CASA DI CURA PRIVATA ACCREDITATA", "address": "VIA GAETANO DI BIASIO, 1" }, "hospital": { "id": "HOS-FRO-00001088", "name": "SAN RAFFAELE CASSINO CASA DI CURA PRIVATA ACCREDITATA" }, "authority": { "id": "STR0000375", "name": "ASL FROSINONE", "code": "120112" } }]
            },
            isCallComplete: false,
        }
    },
    methods: {
        open() {
            this.$refs.mdlAccettazioneNRE.show();
        },
        close() {
            this.$refs.mdlAccettazioneNRE.hide();
        },
        onRicercaAssistito() {
            this.openShowModalLoading();
            this.isCallComplete = false;
            if (this.nre == null || this.nre.trim() == "") {
                toast.error("Inserire NRE valido !")
                this.closeShowModalLoading();
                return;
            }


            this.loadDataByNre("base", this.nre, this.onRicercaAssistitoSuccess, this.onRicercaAssistitoError);
        },
        onRicercaAssistitoSuccess(response) {
            this.jsonData = response.data.data == null ? response.data.data : response.data.data.content[0];
            if (this.jsonData == null) {
                toast.warning(`Non è stato possibile recuperare impegnativa nre: ${this.nre}`, "Ricerca Fallita")
            }
            this.isCallComplete = true;
            this.closeShowModalLoading();
        },
        onRicercaAssistitoError(error) {
            console.log(error);
            this.isCallComplete = false;
            this.closeShowModalLoading();
        },
        onShownModal() {
            this.resetAll();
        },
        closeModalAccettazioneNre() {
            this.resetAll();

            this.close();
        },

        resetAll() {
            this.isCallComplete = false;
            this.nre = null;
            // this.resetJsonData();
        },
        resetJsonData() {
            this.jsonData = {
                patient: {
                    code: null,
                    name: null,
                },
                details: []
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.cursive {
    font-family: cursive !important;
}
</style>